export default {
    variants: {
        standard: {
            bg: 'gray.600',
            color: 'white',
            _hover: {
                background: 'gray.600',
            },
            _disabled: {
                bg: 'gray.600',
                color: 'white',
            },
        },
        subsection: {
            bg: 'gray.100',
            color: 'black',
            _hover: {
                background: 'gray.100',
            },
            _disabled: {
                bg: 'gray.100',
                color: 'black',
            },
        },
        gray: {
            bg: 'gray.100',
            color: 'black',
            _hover: {
                background: 'gray.100',
            },
            _disabled: {
                bg: 'gray.100',
                color: 'black',
            },
        },
    },
    defaultProps: {
        variants: 'standard',
    },
};
//# sourceMappingURL=data:application/json;base64,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